import styled from "styled-components"
import { mobile } from "../../Responsive"

export const Container = styled.div`
    padding: 20px 0px;

    ${mobile({ display: "flex", justifyContent: "center", paddingTop: "30px" })}
`